import type { DbMinimaxVoice } from '@/api/astraea';
import { groupVoicesByGender } from '@/lib/voiceGroups';

interface MinimaxVoiceSelectProps {
  voices: DbMinimaxVoice[];
  value: string;
  onChange: (voiceId: string) => void;
  className?: string;
  placeholder?: string;
  showTags?: boolean;
}

function label(v: DbMinimaxVoice, showTags?: boolean) {
  const base = v.name || v.voice_id;
  if (!showTags || !v.tags?.length) return base;
  return `${base}(${v.tags.join('/')})`;
}

/** MiniMax 中文配音 — 下拉选单按女声/男声分组 */
export default function MinimaxVoiceSelect({ voices, value, onChange, className, placeholder = '请选择声音', showTags }: MinimaxVoiceSelectProps) {
  const { female, male, other } = groupVoicesByGender(voices);
  return (
    <select value={value} onChange={(e) => onChange(e.target.value)} className={className}>
      {!value && <option value="">{placeholder}</option>}
      {female.length > 0 && (
        <optgroup label={`女声 (${female.length})`}>
          {female.map((v) => <option key={v.voice_id} value={v.voice_id}>{label(v, showTags)}</option>)}
        </optgroup>
      )}
      {male.length > 0 && (
        <optgroup label={`男声 (${male.length})`}>
          {male.map((v) => <option key={v.voice_id} value={v.voice_id}>{label(v, showTags)}</option>)}
        </optgroup>
      )}
      {other.length > 0 && (
        <optgroup label={`其他 (${other.length})`}>
          {other.map((v) => <option key={v.voice_id} value={v.voice_id}>{label(v, showTags)}</option>)}
        </optgroup>
      )}
    </select>
  );
}
